import type { CSSProperties, ElementType, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { useInView } from '@/hooks/use-in-view'

interface LineRevealProps {
    lines: Array<ReactNode>
    as?: 'h1' | 'h2' | 'h3' | 'p' | 'div' | 'span' | 'blockquote'
    id?: string
    className?: string
    lineClassName?: string
    delay?: number
    stagger?: number
    trigger?: 'mount' | 'view'
}

const LineReveal = ({
    lines,
    as = 'h2',
    id,
    className,
    lineClassName,
    delay = 0,
    stagger = 0.11,
    trigger = 'view'
}: LineRevealProps): ReactNode => {
    const Component = as as ElementType
    const { ref, inView } = useInView<HTMLElement>()
    const state = trigger === 'mount' || inView ? 'play' : 'wait'

    return (
        <Component ref={ref} id={id} className={className} data-reveal={state}>
            {lines.map((line, index) => (
                <span key={index} className={cn('line-mask', lineClassName)}>
                    <span className='line-inner' style={{ '--d': `${delay + index * stagger}s` } as CSSProperties}>
                        {line}{' '}
                    </span>
                </span>
            ))}
        </Component>
    )
}

export default LineReveal
